import { createFileRoute } from "@tanstack/react-router";
import { buildRouteHead } from "@/lib/seo/routeHead";
import RegulatoryAffairsIndustry from "@/pages/RegulatoryAffairsIndustry";

export const Route = createFileRoute("/en/services/regulatory-affairs-services-for-pharma-biotech")({
  head: () => buildRouteHead("/en/services/regulatory-affairs-services-for-pharma-biotech"),
  component: RegulatoryAffairsIndustry,
});

